import { Route } from "react-router-dom";

import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Users from "@/pages/admin/Users";
import UserDetail from "@/pages/admin/UserDetail";
import Reports from "@/pages/admin/Reports";
import Verify from "@/pages/admin/Verify";
import Finance from "@/pages/admin/Finance";
import Monitoring from "@/pages/admin/Monitoring";
import Ads from "@/pages/admin/Ads";
import Affiliate from "@/pages/admin/Affiliate";
import Circles from "@/pages/admin/Circles";
import Collab from "@/pages/admin/Collab";
import Categories from "@/pages/admin/Categories";
import Launch from "@/pages/admin/Launch";
import Ops from "@/pages/admin/Ops";
import Storage from "@/pages/admin/Storage";
import Payouts from "@/pages/admin/Payouts";
import Programs from "@/pages/admin/Programs";
import ProgramDetail from "@/pages/admin/ProgramDetail";
import Support from "@/pages/admin/Support";
import PreLaunch from "@/pages/admin/PreLaunch";
import GuideAnalytics from "@/pages/admin/GuideAnalytics";
import Campaigns from "@/pages/admin/Campaigns";
import Traffic from "@/pages/admin/Traffic";
import SmartRedirect from "@/pages/admin/SmartRedirect";

export const adminRoutes = (
  <Route path="admin" element={<AdminLayout />}>
    <Route index element={<Overview />} />
    <Route path="users" element={<Users />} />
    <Route path="users/:id" element={<UserDetail />} />
    <Route path="reports" element={<Reports />} />
    <Route path="verify" element={<Verify />} />
    <Route path="finance" element={<Finance />} />
    <Route path="payouts" element={<Payouts />} />
    <Route path="monitoring" element={<Monitoring />} />
    <Route path="ads" element={<Ads />} />
    <Route path="affiliate" element={<Affiliate />} />
    <Route path="programs" element={<Programs />} />
    <Route path="programs/:id" element={<ProgramDetail />} />
    <Route path="support" element={<Support />} />
    <Route path="circles" element={<Circles />} />
    <Route path="collab" element={<Collab />} />
    <Route path="categories" element={<Categories />} />
    <Route path="launch" element={<Launch />} />
    <Route path="prelaunch" element={<PreLaunch />} />
    <Route path="ops" element={<Ops />} />
    <Route path="storage" element={<Storage />} />
    <Route path="guide-analytics" element={<GuideAnalytics />} />
    <Route path="campaigns" element={<Campaigns />} />
    <Route path="traffic" element={<Traffic />} />
    <Route path="smart-redirect" element={<SmartRedirect />} />
  </Route>
);
